import { Field, Int } from '@nestjs/graphql'
import { BaseCreateDto } from '../base/baseCreate.dto'
import { ArgsType } from '@nestjs/graphql'

@ArgsType()
export class CreateCategoryDto extends BaseCreateDto<CreateCategoryDto> {
  @Field()
  name!: string

  @Field(t => Int, { nullable: true })
  parentCategoryId?: number | null

  @Field(t => Int, { nullable: true })
  sortOrder?: number | null
}
